module.exports = __webpack_public_path__ + "img/xdny_s.d2c4ae3.png";